import { render, staticRenderFns } from "./SearchBarFilterStandAlone.vue?vue&type=template&id=48550e86&scoped=true&"
import script from "./SearchBarFilterStandAlone.vue?vue&type=script&lang=js&"
export * from "./SearchBarFilterStandAlone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48550e86",
  null
  
)

export default component.exports